import React, { FC } from 'react';
import styles from './Badge.module.css';
import { Typography, TypographyTagVariants } from '../Typography';

export enum BadgeType {
    success = 'success',
    limeGreen = 'lime-green',
    warning = 'warning',
    info = 'info',
    danger = 'danger',
}

interface BadgeProps {
    label: string;
    type: BadgeType;
    icon: string;
}

export const Badge: FC<BadgeProps> = ({ label, type, icon }) => {
    return (
        <span className={`badge ${styles.badge} ${styles[`badge-${type}`]}`}>
            <Typography tagVariant={TypographyTagVariants.span}>
                <i className={`${icon} me-1`} />
            </Typography>{' '}
            <Typography tagVariant={TypographyTagVariants.span}>{label}</Typography>
        </span>
    );
};
